/*! @nrk/core-suggest v1.3.5 - Copyright (c) 2017-2022 NRK */
'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var IS_BROWSER = typeof window !== 'undefined';
IS_BROWSER && /(android)/i.test(navigator.userAgent); // Bad, but needed

IS_BROWSER && /iPad|iPhone|iPod/.test(String(navigator.platform));
var IS_IE11 = IS_BROWSER && window.msCrypto; // msCrypto only exists in IE11
// Mock HTMLElement for Node

if (!IS_BROWSER && !global.HTMLElement) {
  global.HTMLElement = /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);
    }

    return _createClass(_class);
  }();
}
/**
* escapeHTML
* @param {String} str A string with potential html tokens
* @return {String} Escaped HTML string according to OWASP recommendation
*/

var ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '/': '&#x2F;',
  '\'': '&#x27;'
};
function escapeHTML(str) {
  return String(str || '').replace(/[&<>"'/]/g, function (_char) {
    return ESCAPE_MAP[_char];
  });
}
/**
* closest
* @param {Element} element Element to traverse up from
* @param {String} selector A selector to search for matching parents or element itself
* @return {Element|null}  Element which is the closest ancestor matching selector
*/

var closest$1 = function () {
  var proto = typeof window === 'undefined' ? {} : window.Element.prototype;
  var match = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;
  return proto.closest ? function (el, css) {
    return el.closest(css);
  } : function (el, css) {
    // IE jumps to shadow SVG DOM on clicking an SVG defined by <use>.
    // If so, jump back to <use> element and traverse real DOM
    if (el.correspondingUseElement) el = el.correspondingUseElement;

    for (; el; el = el.parentElement) {
      if (match.call(el, css)) return el;
    }

    return null;
  };
}();
/**
* dispatchEvent - with infinite loop prevention
* @param {Element} element The target object
* @param {String} name The event name
* @param {Object} detail Detail object (bubbles and cancelable is set to true)
* @return {Boolean} Whether the event was canceled. Returns true if either event's cancelable attribute value is false or its preventDefault() method was not invoked, and false otherwise.
*/

function dispatchEvent(element, name) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var ignore = "prevent_recursive_dispatch_maximum_callstack".concat(name);
  var event;
  if (element[ignore]) return true; // We are already processing this event, so skip sending a new one
  else element[ignore] = true; // Add name to dispatching ignore

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(name, {
      bubbles: true,
      cancelable: true,
      detail: detail
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(name, true, true, detail);
  } // IE reports incorrect event.defaultPrevented
  // but correct return value on element.dispatchEvent


  var result = element.dispatchEvent(event);
  element[ignore] = null; // Remove name from dispatching ignore

  return result; // Follow W3C standard for return value
}
/**
* getUUID
* @return {String} A generated unique ID
*/

function getUUID() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
}
/**
 * toggleAttribute (Ponyfill for IE and Edge, fixes #299)
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/toggleAttribute
 * @param {Element} el  Single DOM Element
 * @param {String} name The name of the attribute to be toggled
 * @param {Boolean} force Force attribute to be added or removed regardless of previous state
 */

function toggleAttribute(el, name) {
  var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !this.hasAttribute(name);
  if (!force === el.hasAttribute(name)) el[force ? 'setAttribute' : 'removeAttribute'](name, '');
  return force;
}
/**
* queryAll
* @param {String|NodeList|Array|Element} elements A CSS selector string, nodeList, element array, or single element
* @param {Element} context Node to look for elements within
* @return {Element[]} Array of elements
*/

function queryAll(elements) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

  if (elements) {
    if (elements.nodeType) return [elements];
    if (typeof elements === 'string') return [].slice.call(context.querySelectorAll(elements));
    if (elements.length) return [].slice.call(elements);
  }

  return [];
}

var KEY = {
  DOWN_IE: 'Down',
  DOWN: 'ArrowDown',
  UP_IE: 'Up',
  UP: 'ArrowUp',
  ENTER: 'Enter',
  ESC_IE: 'Esc',
  ESC: 'Escape',
  END: 'End',
  HOME: 'Home',
  PAGEDOWN: 'PageDown',
  PAGEUP: 'PageUp'
};
var AJAX_DEBOUNCE = 500;
var ARIA_LIVE_DELAY = 300; // 300 ms established as sufficient, through testing, for messages to register properly in sr-queue and also support longer label/placeholder-combos.

var ARIA_LIVE_FILTERED = 'Ingen forslag vises';
var ARIA_LIVE_COUNT = '{{value}} forslag vises';

var CoreSuggest = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CoreSuggest, _HTMLElement);

  var _super = _createSuper(CoreSuggest);

  function CoreSuggest() {
    _classCallCheck(this, CoreSuggest);

    return _super.apply(this, arguments);
  }

  _createClass(CoreSuggest, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;

      this._observer = new window.MutationObserver(function () {
        return onMutation(_this);
      });

      this._observer.observe(this, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['hidden']
      });

      this._xhr = new window.XMLHttpRequest();
      this.id = this.id || getUUID();
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('autocomplete', 'off');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('aria-expanded', false);
      this.input.setAttribute('aria-controls', this.id);
      this._ariaLiveSpan = appendResultsNotificationSpan(this);
      document.addEventListener('click', this);
      document.addEventListener('input', this);
      document.addEventListener('keydown', this);
      document.addEventListener('focusin', this);
      setTimeout(function () {
        return onMutation(_this);
      }); // Ensure limit is respected

      if (document.activeElement === this.input) this.hidden = false; // Open if active
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('click', this);
      document.removeEventListener('input', this);
      document.removeEventListener('keydown', this);
      document.removeEventListener('focusin', this); // Clear internals to aid garbage collection

      this._observer.disconnect();

      clearTimeout(this._ariaLiveTimeout); // Clear existing timeout

      if (this._ariaLiveSpan.parentNode) this._ariaLiveSpan.parentNode.removeChild(this._ariaLiveSpan);
      this._observer = this._input = this._regex = this._xhr = this._xhrTime = this._ariaLiveDelay = this._ariaLiveTimeout = this._ariaLiveSpan = null;
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name) {
      if (!this._observer) return;
      if (name === 'hidden') this.input.setAttribute('aria-expanded', !this.hidden);
      if (name === 'highlight') onMutation(this);
    }
    /**
     * Use `focusin` because it bubbles (`focus` does not)
     * @param {KeyboardEvent | FocusEvent | InputEvent | MouseEvent} event
     */

  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      if (event.ctrlKey || event.altKey || event.metaKey || event.defaultPrevented) return;
      if (event.type === 'focusin' || event.type === 'click') onClick(this, event);
      if (event.type === 'keydown') onKey(this, event);
      if (event.type === 'input') onInput(this, event);
    }
  }, {
    key: "escapeHTML",
    value: function escapeHTML$1(str) {
      return escapeHTML(str);
    }
  }, {
    key: "_clearLiveRegion",
    value: function _clearLiveRegion() {
      clearTimeout(this._ariaLiveTimeout); // Clear existing timeout

      this._ariaLiveSpan.textContent = null;
    }
    /**
     * @param {String} label
     * @returns {void}
     */

  }, {
    key: "pushToLiveRegion",
    value: function pushToLiveRegion(label) {
      var _this2 = this;

      if (!this._observer || !this._ariaLiveSpan) return; // Abort if disconnectedCallback has been called or no _ariaLiveSpan

      clearTimeout(this._ariaLiveDebounce); // Debounce multiple calls in the delay-interval
      // Delaying the update of textContent is necesary for consistent behavior in NVDA

      this._ariaLiveDebounce = setTimeout(function () {
        clearTimeout(_this2._ariaLiveTimeout); // Clear existing timeout

        _this2._ariaLiveSpan.textContent = label; // Delay clearing to successfully register change in textContent with screen readers

        _this2._ariaLiveTimeout = setTimeout(function () {
          return _this2._clearLiveRegion();
        }, ARIA_LIVE_DELAY);
      }, ARIA_LIVE_DELAY);
    }
    /**
     * @returns {HTMLInputElement}
     */

  }, {
    key: "input",
    get: function get() {
      if (this._input && this._input.getAttribute('list') === this.id) return this._input; // Speed up

      return (this._input = this.id && document.querySelector("input[list=".concat(this.id, "]"))) || this.previousElementSibling;
    } // Always return string consistent with .value or .className

  }, {
    key: "ajax",
    get: function get() {
      return this.getAttribute('ajax') || '';
    },
    set: function set(url) {
      this.setAttribute('ajax', url);
    }
  }, {
    key: "limit",
    get: function get() {
      return Math.max(0, this.getAttribute('limit')) || Infinity;
    },
    set: function set(_int) {
      this.setAttribute('limit', _int);
    }
    /**
     * @returns {'on' | 'off' | 'keep'} defaults to `'on'`
     */

  }, {
    key: "highlight",
    get: function get() {
      return String(/^on|off|keep$/i.exec(this.getAttribute('highlight')) || 'on').toLowerCase();
    },
    set: function set(str) {
      this.setAttribute('highlight', str);
    } // Must set attribute for IE11

  }, {
    key: "hidden",
    get: function get() {
      return this.hasAttribute('hidden');
    },
    set: function set(val) {
      toggleAttribute(this, 'hidden', val);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['hidden', 'highlight'];
    }
  }]);

  return CoreSuggest;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

function appendResultsNotificationSpan(self) {
  if (!self._observer || self._ariaLiveSpan) return; // Abort if disconnectedCallback has been called

  document.body.insertAdjacentHTML('beforeend', '<span aria-live="polite" style="position: absolute !important; overflow: hidden !important; width: 1px !important; height: 1px !important; clip: rect(0, 0, 0, 0) !important"></span>');
  return document.body.lastElementChild;
}
/**
 * Send textContent to be read by screen readers only if attribute to opt-in is present
 * Uses attribute `'data-sr-read-text-content'`
 *
 * @param {CoreSuggest} self Core suggest element
 * @param {String} textContent label to be read
 * @returns {void}
 */


function notifyTextContent(self, textContent) {
  if (!self.hasAttribute('data-sr-read-text-content')) return; // Abort if not present

  self.pushToLiveRegion(textContent);
}
/**
 * Notify screen readers how many results are visible
 * textContent uses attribute `'data-sr-count-message'`
 * Replaces `{{value}}` with number of visible items
 *
 * @param {CoreSuggest} self Core suggest element
 * @param {Number} items Number of visible items
 * @returns {void}
 */


function notifyResultCount(self, items) {
  var label = self.getAttribute('data-sr-count-message');
  if (label === '') return; // Abort if label is set to explicit empty string

  self.pushToLiveRegion((label || ARIA_LIVE_COUNT).replace('{{value}}', items));
}
/**
 * Notify screen readers when all results are hidden by filter
 * textContent uses attribute `'data-sr-empty-message'`
 *
 * @param {CoreSuggest} self Core suggest element
 * @returns {void}
 */


function notifyResultsEmpty(self) {
  var label = self.getAttribute('data-sr-empty-message');
  if (label === '') return; // Abort if label is set to explicit empty string

  self.pushToLiveRegion(label || ARIA_LIVE_FILTERED);
}
/**
 * @param {Element} item
 * @param {Boolean} show
 */


function toggleItem(item, show) {
  var li = item.parentElement; // JAWS requires hiding parent <li> (if existing)

  if (li.nodeName === 'LI') toggleAttribute(li, 'hidden', show);
  toggleAttribute(item, 'hidden', show);
}
/**
 * Callback for mutationObserver
 * Enhances items with aria-label, tabindex and type="button"
 * Respects limit attribute
 * Updates <mark> tags for highlighting according to attribute
 * Trigger messages for screen readers
 * This can happen quite frequently so make it fast
 * @param {CoreSuggest} self Core suggest element
 * @returns {void}
 */


function onMutation(self) {
  if (!self._observer) return; // Abort if disconnectedCallback has been called (this/self._observer is null)

  var needle = self.input && self.input.value ? self.input.value.toLowerCase().trim() : null;
  var items = self.querySelectorAll('a:not([hidden]),button:not([hidden])');
  var limit = Math.min(items.length, self.limit); // Remove old highlights only when highlight-mode is not 'keep'

  if (self.highlight !== 'keep') {
    var marks = self.getElementsByTagName('mark');

    while (marks[0]) {
      var parent = marks[0].parentNode;
      parent.replaceChild(document.createTextNode(marks[0].textContent), marks[0]);
      parent.normalize && parent.normalize();
    }
  }

  self._empty = items.length === 0;

  for (var i = 0, l = items.length; i < l; ++i) {
    items[i].setAttribute('aria-label', "".concat(items[i].textContent, ", ").concat(i + 1, " av ").concat(limit));
    items[i].setAttribute('tabindex', '-1'); // setAttribute a bit faster than tabIndex prop

    items[i].setAttribute('type', 'button'); // Ensure <button> does not submit forms

    toggleItem(items[i], i >= limit);
  } // Highlights disabled for IE11 due to bugs in range calculation


  if (needle && self.highlight === 'on' && !IS_IE11) {
    var range = document.createRange();
    var iterator = document.createNodeIterator(self, window.NodeFilter.SHOW_TEXT, null, false);
    var haystack = self.textContent.toLowerCase();
    var length = needle.length;
    var hits = [];

    for (var start = 0; (start = haystack.indexOf(needle, start)) !== -1; start += length) {
      hits.push(start);
    }

    for (var _start = 0, hitsLength = hits.length, node; node = iterator.nextNode();) {
      var nodeStart = _start;
      var nodeEnd = _start += node.textContent.length;

      for (var _i = 0; _i < hitsLength; ++_i) {
        var hitStart = Math.max(hits[_i] - nodeStart, 0); // Avoid splitting at minus index

        var hitEnd = Math.min(nodeEnd, hits[_i] + length) - nodeStart; // Avoid splitting after content end

        if (hitStart < hitEnd) {
          range.setStart(node, hitStart);
          range.setEnd(node, hitEnd);
          range.surroundContents(document.createElement('mark'));
          _start = nodeStart + hitEnd; // Reset start to character after <mark>

          iterator.nextNode(); // skip newly created node next

          break;
        }
      }
    }
  } // Send messages for screen readers


  var hasNoItems = !self.querySelector('a,button'); // Accounts for hidden as well

  var hasNotSearchedYet = hasNoItems && !self.input.value;
  var textContent = hasNoItems && self.textContent.trim();
  if (self.hidden || hasNotSearchedYet) self._clearLiveRegion();else if (textContent) notifyTextContent(self, textContent);else if (items.length) notifyResultCount(self, items.length);else notifyResultsEmpty(self);

  self._observer.takeRecords(); // Empty mutation queue to skip mutations done by highlighting

}
/**
 * Handle input event in connected input
 * Triggers built-in ajax functionality if `ajax`-attribute is set
 *  * Suggestions will not be filtered by input if this is the case
 * @param {CoreSuggest} self Core suggest element
 * @param {InputEvent} event
 * @returns {void}
 */


function onInput(self, event) {
  if (event.target !== self.input || onAjax(self)) return;
  filterItemsByInput(self);
}
/**
 * Performs filtering of core-suggest items
 * Dispatches event
 *  * `suggest.filter`
 * Filtering is aborted if
 *  * event.preventDefault() is called on on `suggest.filter` event
 *  * input has no value
 * @param {CoreSuggest} self Core suggest element
 * @fires `suggest.filter`
 */


function filterItemsByInput(self) {
  if (!dispatchEvent(self, 'suggest.filter') || !(self.input && self.input.value)) return;
  var value = self.input.value.toLowerCase();
  var items = self.querySelectorAll('a,button');

  for (var i = 0, l = items.length; i < l; ++i) {
    toggleItem(items[i], (items[i].value || items[i].textContent).toLowerCase().indexOf(value) === -1);
  }
}
/**
 *
 * @param {CoreSuggest} self Core suggest element
 * @param {KeyboardEvent} event
 * @returns {void}
 */


function onKey(self, event) {
  if (!self.contains(event.target) && self.input !== event.target) return;
  var items = [self.input].concat(queryAll('[tabindex="-1"]:not([hidden])', self));
  var key = event.key,
      target = event.target,
      _event$item = event.item,
      item = _event$item === void 0 ? false : _event$item;

  if (key === KEY.DOWN || key === KEY.DOWN_IE) {
    item = items[items.indexOf(target) + 1] || items[0];
  } else if (key === KEY.UP || key === KEY.UP_IE) {
    item = items[items.indexOf(target) - 1] || items.pop();
  } else if (self.contains(target)) {
    // Aditional shortcuts if focus is inside list
    if (key === KEY.END || key === KEY.PAGEDOWN) {
      item = items.pop();
    } else if (key === KEY.HOME || key === KEY.PAGEUP) {
      item = items[1];
    } else if (key !== KEY.ENTER) {
      items[0].focus();
    }
  }

  setTimeout(function () {
    return self.hidden = key === KEY.ESC || key === KEY.ESC_IE;
  }); // Let focus buble first

  if (item || key === KEY.ESC || key === KEY.ESC_IE) event.preventDefault(); // Prevent leaving maximized safari

  if (item) item.focus();
}
/**
 * Handle focus or click events
 * Dispatches `suggest.select`
 * @param {CoreSuggest} self Core suggest element
 * @param {FocusEvent | MouseEvent} event
 * @returns {void}
 */


function onClick(self, event) {
  var item = event.type === 'click' && self.contains(event.target) && closest$1(event.target, 'a,button');
  var show = !item && (self.contains(event.target) || self.input === event.target && !self.input.disabled);
  var delayedFilter = false;

  if (item && dispatchEvent(self, 'suggest.select', item)) {
    self.input.value = item.value || item.textContent.trim();
    self.input.focus();
    delayedFilter = true;
  } // setTimeout: fix VoiceOver Safari moving focus to parentElement and let focus bubbe first


  setTimeout(function () {
    self.hidden = !show; // Filter after hidden to avoid announcing to liveRegion in mutationObserver

    if (delayedFilter) filterItemsByInput(self);
  });
}
/**
 * Handle ajax event using ajax attribute
 * @param {CoreSuggest} self Core suggest element
 * @returns {Boolean} Returns true if Core Suggest element has `ajax` attribute value, false if not
 */


function onAjax(self) {
  if (!self.ajax) return;
  clearTimeout(self._xhrTime); // Clear previous search

  self._xhr.abort(); // Abort previous request


  self._xhr.responseError = null;
  self._xhrTime = setTimeout(onAjaxSend, AJAX_DEBOUNCE, self); // Debounce

  return true;
}
/**
 * Handle ajax request, replacing `{{value}}` in ajax-attribute with URIEncoded value from input
 * Dispatches the following events
 *  * suggest.ajax.beforeSend
 *  * suggest.ajax.error
 *  * suggest.ajax
 * @param {CoreSuggest} self Core suggest element
 * @returns {void}
 */


function onAjaxSend(self) {
  if (!self._observer || !self.input.value) return; // Abort if disconnectedCallback has completed or input is empty

  if (dispatchEvent(self, 'suggest.ajax.beforeSend', self._xhr)) {
    self._xhr.onerror = function () {
      self._xhr.responseError = 'Error: Network request failed';
      dispatchEvent(self, 'suggest.ajax.error', self._xhr);
    };

    self._xhr.onload = function () {
      if (self._xhr.status !== 200) return dispatchEvent(self, 'suggest.ajax.error', self._xhr);

      try {
        self._xhr.responseJSON = JSON.parse(self._xhr.responseText);
      } catch (error) {
        self._xhr.responseJSON = false;
        self._xhr.responseError = error.toString();
        dispatchEvent(self, 'suggest.ajax.error', self._xhr);
      } // Data successfully received


      dispatchEvent(self, 'suggest.ajax', self._xhr);
    };

    self._xhr.open('GET', self.ajax.replace('{{value}}', window.encodeURIComponent(self.input.value)), true);

    self._xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest'); // https://en.wikipedia.org/wiki/List_of_HTTP_header_fields#Requested-With


    self._xhr.send();
  }
}

var version = "1.3.5";

/**
* closest
* @param {Element} el Element to traverse up from
* @param {String} css A selector to search for matching parents or element itself
* @return {Element|null}  Element which is the closest ancestor matching selector
*/

var closest = function () {
  var proto = typeof window === 'undefined' ? {} : window.Element.prototype;
  var match = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;
  return proto.closest ? function (el, css) {
    return el.closest(css);
  } : function (el, css) {
    for (; el; el = el.parentElement) {
      if (match.call(el, css)) {
        return el;
      }
    }

    return null;
  };
}();
/**
* customElementToReact
* @param {Class|Function} elementClass A custom element definition.
* @param {Array} options Props and custom events
* @return {Object} A React component
*/


function customElementToReact(elementClass, options) {
  if (options === void 0) options = {};
  var name = elementClass.name || String(elementClass).match(/function ([^(]+)/)[1]; // String match for IE11

  var dashCase = name.replace(/.[A-Z]/g, function (ref) {
    var a = ref[0];
    var b = ref[1];
    return a + "-" + b;
  }); // NameName -> name-name

  var customProps = options.props || [];
  var customEvents = options.customEvents || [];
  var eventMap = customEvents.reduce(function (map, eventName) {
    map[eventName] = "on" + eventName.replace(/(^|\.)./g, function (m) {
      return m.slice(-1).toUpperCase();
    }); // input.filter => onInputFilter

    return map;
  }, {});
  var skipProps = customProps.concat('forwardRef', Object.keys(eventMap).map(function (onEventName) {
    return eventMap[onEventName];
  }));
  var tagName = (dashCase + "-" + (options.suffix || 'react')).replace(/\W+/g, '-').toLowerCase();
  return /*@__PURE__*/function (superclass) {
    function anonymous(props) {
      var this$1$1 = this;
      superclass.call(this, props); // Register ref prop for accessing custom element https://reactjs.org/docs/refs-and-the-dom.html#callback-refs

      this.ref = function (el) {
        if (typeof this$1$1.props.forwardRef === 'function') {
          this$1$1.props.forwardRef(el);
        } else if (this$1$1.props.forwardRef) {
          this$1$1.props.forwardRef.current = el;
        }

        return this$1$1.el = el;
      }; // Register event handler on component for each custom event


      Object.keys(eventMap).forEach(function (eventName) {
        var onEventName = eventMap[eventName];

        this$1$1[eventName] = function (event) {
          if (this$1$1.props[onEventName] && closest(event.target, this$1$1.el.nodeName) === this$1$1.el) {
            this$1$1.props[onEventName](event);
          }
        };
      });
    }

    if (superclass) anonymous.__proto__ = superclass;
    anonymous.prototype = Object.create(superclass && superclass.prototype);
    anonymous.prototype.constructor = anonymous;

    anonymous.prototype.componentDidMount = function componentDidMount() {
      var this$1$1 = this; // Run connectedCallback() after React componentDidMount() to allow React hydration to run first

      if (!window.customElements.get(tagName)) {
        window.customElements.define(tagName, elementClass);
      } // Populate properties on custom element


      customProps.forEach(function (propName) {
        if (propName in this$1$1.props) {
          this$1$1.el[propName] = this$1$1.props[propName];
        }
      }); // Register events on custom element

      customEvents.forEach(function (eventName) {
        this$1$1.el.addEventListener(eventName, this$1$1[eventName]);
      });
    };

    anonymous.prototype.componentDidUpdate = function componentDidUpdate(prev) {
      var this$1$1 = this; // Sync prop changes to custom element

      customProps.forEach(function (propName) {
        if (prev[propName] !== this$1$1.props[propName]) {
          this$1$1.el[propName] = this$1$1.props[propName];
        }
      });
    };

    anonymous.prototype.componentWillUnmount = function componentWillUnmount() {
      var this$1$1 = this; // Remove event handlers on custom element on unmount

      customEvents.forEach(function (eventName) {
        this$1$1.el.removeEventListener(eventName, this$1$1[eventName]);
      });
    };

    anonymous.prototype.render = function render() {
      var this$1$1 = this; // Convert React props to CustomElement props https://github.com/facebook/react/issues/12810

      return React__default["default"].createElement(tagName, Object.keys(this.props).reduce(function (thisProps, propName) {
        if (skipProps.indexOf(propName) === -1) {
          // Do not render customEvents and custom props as attributes
          if (propName === 'className') {
            thisProps["class"] = this$1$1.props[propName];
          } // Fixes className for custom elements
          else if (this$1$1.props[propName] === true) {
            thisProps[propName] = '';
          } // Fixes boolean attributes
          else if (this$1$1.props[propName] !== false) {
            thisProps[propName] = this$1$1.props[propName];
          } // Pass only truthy, non-function props

        }

        return thisProps;
      }, {
        ref: this.ref
      }));
    };

    return anonymous;
  }(React__default["default"].Component);
}

var coreSuggest = customElementToReact(CoreSuggest, {
  customEvents: ['suggest.filter', 'suggest.select', 'suggest.ajax', 'suggest.ajax.beforeSend', 'suggest.ajax.error'],
  suffix: version
});

module.exports = coreSuggest;
